module.exports = __webpack_public_path__ + "4852bd2a8e2fb398d58a165b28b3f613.png";